export enum FourDirection {
    Up,
    Right,
    Down,
    Left

}